import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useOptionalWarpTransition } from './WarpTransitionProvider';

const WarpLink = ({
  to,
  label,
  variant = 'roll',
  onClick,
  onBeforeNavigate = () => {},
  children,
  ...linkProps
}) => {
  const warpTransition = useOptionalWarpTransition();

  const handleClick = (event) => {
    onClick?.(event);
    if (event.defaultPrevented) return;

    const modifiedClick =
      event.button !== 0 ||
      event.metaKey ||
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey;

    if (modifiedClick) return;

    if (!warpTransition) {
      onBeforeNavigate();
      return;
    }

    event.preventDefault();
    warpTransition.startTransition({
      to,
      label,
      variant,
      onNavigate: onBeforeNavigate,
    });
  };

  return (
    <Link
      {...linkProps}
      to={to}
      onClick={handleClick}
      aria-disabled={warpTransition?.isTransitioning || undefined}
    >
      {children}
    </Link>
  );
};

WarpLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['roll', 'danger', 'portal']),
  onClick: PropTypes.func,
  onBeforeNavigate: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default WarpLink;
